import axiosProtectedInstance from "../auth/axiosProtectedInstance";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
//import { saveAs } from "file-saver";
import InvoiceComponent from "../MyViews/TicketsView/InvoiceComponent";
import { createRoot } from "react-dom/client";

const ticketService = {};

ticketService.addTicket = async function (ticket) {
  try {
    const response = await axiosProtectedInstance.post(`/tickets/addTicket`, {
      ticket,
    });

    if (
      response.status === 201 &&
      response.data.ticketData &&
      ticket.downloadTicket === true
    ) {
      const ticketData = {
        ...response.data.ticketData, // Include all existing ticket data from the response
        addServiceCharge: ticket.addServiceCharge, // Include addServiceCharge from the ticket prop
        includeGST: ticket.includeGST, // Include includeGST from the ticket prop
      };
      await ticketService.generatePDF(ticketData);
    }

    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.data?.message ||
      "Failed to Add the Ticket!. Kindly try again or contact Admin";
    return { errorMessage };
  }
};

ticketService.updateTicket = async function (ticket) {
  try {
    const response = await axiosProtectedInstance.post(
      `/tickets/updateTicketDetails`,
      {
        ticket,
      }
    );
    if (
      response.status === 200 &&
      response.data.ticketData &&
      ticket.downloadTicket === true
    ) {
      const ticketData = {
        ...response.data.ticketData, // Include all existing ticket data from the response
        addServiceCharge: ticket.addServiceCharge, // Include addServiceCharge from the ticket prop
        includeGST: ticket.includeGST, // Include includeGST from the ticket prop
      };
      await ticketService.generatePDF(ticketData);
    }

    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.data?.message ||
      "Failed to Update the Ticket!. Kindly try again or contact Admin";
    return { errorMessage };
  }
};

ticketService.getTickets = async function () {
  try {
    const response = await axiosProtectedInstance.get("/tickets/gettickets");
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.data?.message || "Failed to create the ticket!";
    throw new Error(errorMessage);
  }
};

ticketService.getSingleTicket = async function (value) {
  try {
    const response = await axiosProtectedInstance.get(
      `/tickets/getSingleTicket`,
      {
        params: { value },
      }
    );
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.data?.message ||
      "Failed to get the ticket details!";
    return { errorMessage };
  }
};

ticketService.addCredit = async function (values) {
  try {
    const response = await axiosProtectedInstance.post(`/tickets/addCredit`, {
      values,
    });
    console.log(response);
    return response.data;
  } catch (error) {
    console.log(error);
    const errorMessage =
      error.response?.data?.data?.message ||
      "Failed to Add the Credit Entry!. Kindly try again or contact Admin";
    return { errorMessage };
  }
};

ticketService.updateCredit = async function (values) {
  try {
    const response = await axiosProtectedInstance.post(
      `/tickets/updateCredit`,
      {
        values,
      }
    );
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.data?.message ||
      "Failed to Update the Credit Note!. Kindly try again or contact Admin";
    return { errorMessage };
  }
};

ticketService.generatePDF = async (ticketData) => {
  // Create a temporary div to render the invoice HTML
  const tempDiv = document.createElement("div");
  const A4_WIDTH_PX = 850; // A4 width at 96 DPI
  const A4_HEIGHT_PX = 1350; // A4 height at 96 DPI

  // Set strict dimensions and styles
  Object.assign(tempDiv.style, {
    position: "fixed",
    left: "-9999px",
    width: `${A4_WIDTH_PX}px`,
    height: `${A4_HEIGHT_PX}px`,
    fontSize: "10px", // Base font size
    lineHeight: "1.2",
    fontFamily: "Arial, sans-serif",
  });

  document.body.appendChild(tempDiv);

  // Create a root and render the InvoiceComponent into the temporary div
  const root = createRoot(tempDiv);
  const renderPromise = new Promise((resolve) => {
    root.render(
      <InvoiceComponent
        ticketData={ticketData}
        onRenderComplete={() => {
          // This callback will be called when all images are loaded and component is fully rendered
          resolve();
        }}
      />
    );
  });
  try {
    await renderPromise;

    // Configure html2canvas for high quality
    const canvas = await html2canvas(tempDiv, {
      logging: false,
      useCORS: true,
      scale: 2,
      width: A4_WIDTH_PX,
      height: A4_HEIGHT_PX,
      windowWidth: A4_WIDTH_PX,
      windowHeight: A4_HEIGHT_PX,
    });

    // Create PDF with proper dimensions
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
      compress: true,
    });

    const imgData = canvas.toDataURL("image/png", 1.0);

    // Calculate dimensions to fit A4 page
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight, "", "FAST");

    // Save with error handling
    try {
      pdf.save(`TicketInv_${ticketData.ticketId}.pdf`);
    } catch (error) {
      console.error("Error saving PDF:", error);
    }
  } catch (error) {
    console.error("Error generating PDF:", error);
    throw error;
  } finally {
    // Cleanup
    root.unmount();
    document.body.removeChild(tempDiv);
  }
};
ticketService.transferTicket = async function (requestData) {
  try {
    const response = await axiosProtectedInstance.post(
      `/tickets/transferTicket`,
      {
        requestData,
      }
    );
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.data?.message ||
      "Failed to Transfer the Ticket's, kindly try again or contact admin!";
    return { errorMessage };
  }
};

ticketService.transferCredit = async function (requestData) {
  try {
    const response = await axiosProtectedInstance.post(
      `/tickets/transferCreditEntry`,
      {
        requestData,
      }
    );
    return response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.data?.message ||
      "Failed to Transfer the Credit Entry, kindly try again or contact admin!";
    return { errorMessage };
  }
};

export default ticketService;
